// import "./style.css";

import BadgeEstados from "../../../../../components/BadgeEstado";
import { DobleArrowRightIcon } from "../../../../../components/svgs/DobleArrowRigthIcon";

export const tableData = (data) => {
  const columns = [
    {
      field: "hora",
      headerName: "Hora",
      minWidth: 80,
      flex: 0.2,
      sortable: false,
    },
    {
      field: "numero_acta",
      headerName: "N° Acta",
      minWidth: 80,
      flex: 0.2,
      sortable: false,
    },
    {
      field: "",
      headerName: "Interacción",
      minWidth: 200,
      flex: 0.6,
      sortable: false,
      renderCell: (params) => {
        return (
          <p className="m-0">
            <BadgeEstados estado_id={params.row.old_estado} size={"xsm"} /> <DobleArrowRightIcon />{" "}
            <BadgeEstados estado_id={params.row.new_estado} size={"xsm"} />
          </p>
        );
      },
    },
    // {
    //   field: "actions",
    //   headerName: "Ver",
    //   minWidth: 50,
    //   flex: 0.4,
    //   sortable: false,
    // },
  ];

  const rows =
    data?.map((d, index) => {
      return {
        id:index,
        numero_acta: d?.numero_acta,
        hora: d?.hora,
        old_estado: d?.old_estado,
        new_estado: d?.new_estado,
      };
    }) || [];

  const filter = (d, value) => {
    value = value.toLowerCase();

    return (
      String(d.hora)?.toString().toLowerCase().includes(value) ||
      String(d.old_estado)?.toString().toLowerCase().includes(value) ||
      String(d.new_estado)?.toString().toLowerCase().includes(value) ||
      String(d.numero_acta)?.toString().toLowerCase().includes(value) ||
      String(d.id)?.toString().toLowerCase().includes(value)
    );
  };

  return { columns, rows, filter };
};
